var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('Header',{attrs:{"id":"header"}}),(_vm.myplayer)?_c('thePlayer'):_vm._e(),(_vm.myslideshow)?_c('theSlideshow'):_vm._e(),_c('router-view',{staticClass:"mb-5"}),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }